import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=e480e34a&scoped=true&"
import script from "./baseTable.vue?vue&type=script&lang=js&"
export * from "./baseTable.vue?vue&type=script&lang=js&"
import style0 from "./baseTable.vue?vue&type=style&index=0&id=e480e34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e480e34a",
  null
  
)

export default component.exports